import React from 'react';
import { StyleSheet } from 'react-native';

import { SegmentedControl } from '~/components/core';
import { useStyles } from '~/hooks';
import { scaleSize } from '~/constants/scale';
import { Theme } from '~/theme';

export type ResultMode = 'backtest' | 'live';

type Props = {
    mode: ResultMode;
    onChange: (mode: ResultMode) => void;
};

const OPTIONS = [
    // Live first: for a strategy that is trading, what it actually did is the more interesting
    // half, and it is the default on an active strategy.
    { value: 'live' as const, label: 'ai-strategy-mode-live' },
    { value: 'backtest' as const, label: 'ai-strategy-mode-backtest' },
];

// Global to the screen rather than per tab, so two tabs cannot disagree about which mode the
// user is in. Setup is off this axis and keeps its own Submitted/Optimized control.
export default function ResultModeToggle({ mode, onChange }: Props) {
    const styles = useStyles(stylesGenerator);

    return <SegmentedControl options={OPTIONS} value={mode} onChange={onChange} containerStyle={styles.control} />;
}

const stylesGenerator = (_theme: Theme) =>
    StyleSheet.create({
        control: {
            marginHorizontal: scaleSize(12),
            marginBottom: scaleSize(8),
        },
    });
